import { type vDirType } from 'owa-vdir-types';

export const OPTION_ROUTE_KEYWORD: string = 'options';
